export default "__VITE_ASSET__cpRge0mo__";